module.exports = new __parcel__URL__("train_100_inactive.186e86e3.png").toString();